module.exports = __webpack_public_path__ + "img/20260224_ICLR.cb47f5c1.png";